import Button from "@mui/material/Button";

import RefreshIcon from "@mui/icons-material/Refresh";
import ErrorIcon from "@mui/icons-material/Error";

const RetryPanel = ({ retry }: { retry: () => void }) => {
  return (
    <div
      style={{
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 20,
          paddingBottom: 100,
        }}
      >
        <ErrorIcon
          // color="error"
          style={{ fontSize: 100, color: "#595959" }}
        />

        <div
          style={{
            color: "#595959",
            fontSize: 36,
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          Oops! Something went wrong.
        </div>

        <div style={{ color: "#595959", fontSize: 16, fontWeight: 300 }}>
          This page didn&#39;t load correctly. Please try again.
        </div>

        <div>
          <Button
            id="retyrPanelButton"
            variant="contained"
            color="error"
            style={{ display: "flex", gap: 6 }}
            onClick={retry}
          >
            <RefreshIcon />
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RetryPanel;
